import { authHeader } from "./auth-header";
import { authHeaderOnlyToken } from "./auth-header-collector";

import { toast } from "react-toastify";
import { getValue } from "@utils/lodash";
import { config } from "../../env";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { saveAs } from "file-saver";

let access_token = localStorage.getItem("accessToken");
let port = window.location.origin.split("//")[1].split(":")[0];

const urlSearchParams = new URLSearchParams(window.location.search);
const urlParams = Object.fromEntries(urlSearchParams.entries());

export const post = (url, payload) => {
  const requestOptions = {
    method: "POST",
    headers: authHeader(url),
    body: JSON.stringify(payload),
  };

  return fetch(`${url}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

export const postWithSource = (url, payload, source) => {
  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + access_token,
      "Content-Type": "application/json",
      source: source
        ? source
        : port === "localhost"
        ?config.SOURCE
        : window.location.origin?.split("//")[1],
    },
    body: JSON.stringify(payload),
  };

  return fetch(`${url}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

export const postFileUpload = (url, payload, source) => {
  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + access_token,
      source: source
        ? source
        : port === "localhost"
       ? config.SOURCE
        : window.location.origin?.split("//")[1],
    },
    body: payload,
  };

  return fetch(`${url}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};
export const postFileUploadOnlyToken = (url, payload) => {
  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + access_token,
      source:
        port === "localhost"
          ?config.SOURCE
          : window.location.origin?.split("//")[1],
    },
    body: payload,
  };

  return fetch(`${url}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

export const patchFileUpload = (url, payload) => {
  const requestOptions = {
    method: "PATCH",
    headers: { Authorization: "Bearer " + access_token },
    body: payload,
  };

  return fetch(`${url}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

export const patch = (url, payload) => {
  const requestOptions = {
    method: "PATCH",
    headers: authHeader(url),
    body: JSON.stringify(payload),
  };

  return fetch(`${url}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

export const patchWitoutPayload = (url, payload) => {
  const requestOptions = {
    method: "PATCH",
    headers: authHeader(url),
  };

  return fetch(`${url}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

export const put = (url, payload) => {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(url),
    body: JSON.stringify(payload),
  };
  return fetch(`${url}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

export const Delete = (url) => {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(url),
  };
  return fetch(`${url}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};
export const DeleteWithPayload = (url, payload) => {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(url),
    body: JSON.stringify(payload),
  };
  return fetch(`${url}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

export const DeletePayload = (url, payload) => {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(url),
    body: JSON.stringify(payload),
  };
  return fetch(`${url}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

export const get = (url) => {
  try {
    const requestOptions = {
      method: "GET",
      headers: authHeader(url),
    };
    return fetch(`${url}`, requestOptions)
      .then(handleResponse)
      .then((data) => {
        return data;
      });
  } catch (error) {
    //console.log(error)
  }
};

export const getWithToken = (url, token) => {
  try {
    const requestOptions = {
      method: "GET",
      headers: authHeader(url, token),
    };
    return fetch(`${url}`, requestOptions)
      .then(handleResponse)
      .then((data) => {
        return data;
      });
  } catch (error) {
    //console.log(error)
  }
};

export const getPayload = (url, payload) => {
  const requestOptions = {
    method: "GET",
    headers: authHeader(url),
    body: JSON.stringify(payload),
  };
  return fetch(`${url}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
};

function logout() {
  localStorage.clear();
}

export const getOnlyToken = (url) => {
  try {
    const requestOptions = {
      method: "GET",
      headers: authHeaderOnlyToken(url),
    };
    return fetch(`${url}`, requestOptions)
      .then(handleResponse)
      .then((data) => {
        return data;
      });
  } catch (error) {
    //console.log(error)
  }
};

export const getFile = async (url, defaultFilename = "download.xlsx") => {
  let access_token = localStorage.getItem("accessToken");
  let port = window.location.origin.split("//")[1].split(":")[0];
  const headers = {
    accept: "*/*",
    source:
      port === "localhost"
        ? config.SOURCE
        : window.location.origin?.split("//")[1],
  };
  if (access_token) {
    headers["Authorization"] = "Bearer " + access_token;
  }

  const requestOptions = {
    method: "GET",
    headers: headers,
  };

  try {
    const response = await fetch(`${url}`, requestOptions);

    if (!response.ok) {
      if (response.status === 401 || response.status === 429) {
        logout();
        window.location.href = `/login`;
        return;
      }
      try {
        const text = await response.text();
        const errData = text && JSON.parse(text);
        const errorMsg =
          (errData && errData.message) || response.statusText || "Download failed";
        if (Array.isArray(errorMsg)) {
          errorMsg.forEach((msg) => toast.error(msg));
        } else {
          toast.error(errorMsg);
        }
        return Promise.reject(errorMsg);
      } catch (e) {
        toast.error(response.statusText || "Download failed");
        return Promise.reject(response.statusText);
      }
    }

    const blob = await response.blob();
    let filename = defaultFilename;
    const disposition = response.headers.get("content-disposition");
    if (disposition && disposition.indexOf("filename") !== -1) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, "").trim();
      }
    }

    saveAs(blob, filename);
    return { success: true };
  } catch (error) {
    console.error("Download file error:", error);
    throw error;
  }
};

export const postOnlyToken = (url, payload) => {
  try {
    const requestOptions = {
      method: "POST",
      headers: authHeaderOnlyToken(url),
      body: JSON.stringify(payload),
    };
    return fetch(`${url}`, requestOptions)
      .then(handleResponse)
      .then((data) => {
        return data;
      });
  } catch (error) {
    //console.log(error)
  }
};

function handleResponse(response) {
  const handleOnClick = async () => {
    // if (window.confirm("Would you like to continue the session?")) {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        source:
          port === "localhost"
            ? config.SOURCE
            : window.location.origin?.split("//")[1],
      },
      body: JSON.stringify({
        refresh_token: getValue(localStorage, `refreshToken`, ""),
      }),
    };
    return fetch(`${config.API_URL}/auth/user/refresh`, requestOptions).then(
      (data) => {
        data.text().then((text) => {
          // const data = text && JSON.parse(text);
          if (!data.ok) {
            if (data.status === 401 || data.status === 429) {
              toast.error("Unauthorized");
              logout();
              window.location.href = `/login`;
            }
          } else {
            let resp = JSON.parse(text);
            localStorage.setItem(
              "accessToken",
              getValue(resp, `data.accessToken`, "")
            );
            localStorage.setItem(
              "refreshToken",
              getValue(resp, `data.refreshToken`, "")
            );
            localStorage.setItem(
              "user",
              JSON.stringify(getValue(resp, `data.user`, ""))
            );
            window.location.reload();
          }
        });
      }
    );
    // } else {
    // 	logout();
    // 	window.location.href = `/login`;
    // }
  };

  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (
      getValue(data, `statusCode`, 0) === 401 ||
      getValue(data, `statusCode`, 0) === 429
    ) {
      if (getValue(urlParams, `code`, "")) {
        let payload = { ...urlParams };
        let queryRequest = QueryRequestHelper(payload);
        logout();
        window.location.href = `/auth/sso/callback?${queryRequest}`;
      } else {
        if (getValue(localStorage, `refreshToken`, "")) {
          logout();
          window.location.href = `/login`;
        } else {
          logout();
          window.location.href = `/login`;
        }
      }
    } else {
      if (!response.ok) {
        if (response.status === 401 || response.status === 429) {
          // auto logout if 401 response returned from api
          if (getValue(localStorage, `refreshToken`, "")) {
            // window.location.href = `/login/refesh`;
            logout();
            window.location.href = `/login`;
          } else {
            logout();
            window.location.href = `/login`;
          }
        }
        const error = (data && data.message) || response.statusText;
        if (
          typeof data.message === "string" &&
          data.message !== "Unauthorized"
        ) {
          const error = (data && data.message) || response.statusText;
          toast.error(error);
        } else {
          getValue(data, `message`, []).forEach((item) => {
            toast.error(item);
          });
        }
        if (getValue(data, `data.mfa_required`, false)) {
          return data;
        } else {
          return Promise.reject(error);
        }
      }
      return data;
    }
  });
}
